import {
  IconArrowBackUpDouble,
  IconArrowForwardUpDouble,
  IconChevronsRight,
} from '@tabler/icons-react'
import { PaginationState, Table } from '@tanstack/react-table'
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronsLeftIcon,
} from 'lucide-react'
import { Button } from './button'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './select'

export interface DataTablePaginationProps<TData> {
  table: Pick<
    Table<TData>,
    | 'setPageSize'
    | 'getPageCount'
    | 'setPageIndex'
    | 'getCanPreviousPage'
    | 'previousPage'
    | 'nextPage'
    | 'getCanNextPage'
  > & {
    getState: () => { pagination: PaginationState }
  }
}

const capitalizeFirstLetter = (value: string = ''): string =>
  value.charAt(0).toUpperCase() + value.slice(1)

export function DataTablePagination<TData>({
  table,
  entityLabel,
  pageRanges = [10, 20],
}: DataTablePaginationProps<TData> & {
  entityLabel: string
  pageRanges?: number[]
}) {
  return (
    <div className='w-full flex justify-end px-2 mt-6'>
      <div className='w-full flex items-center justify-end space-x-6 lg:space-x-8'>
        <div className='flex items-center justify-end gap-x-2'>
          <div className='flex w-[100px] items-center justify-center text-xs font-medium'>
            Página {table.getState().pagination.pageIndex + 1} de{' '}
            {table.getPageCount()}
          </div>
          <div className='flex items-center space-x-2'>
            <Button
              variant='outline'
              onClick={() => table.previousPage()}
              disabled={!table.getCanPreviousPage()}
              size='xs'
            >
              <span className='sr-only'>Ir a la pagina anterior</span>
              <ChevronLeftIcon className='h-4 w-4' />
            </Button>
            <Button
              variant='outline'
              onClick={() => table.nextPage()}
              disabled={!table.getCanNextPage()}
              size='xs'
            >
              <span className='sr-only'>Ir a la siguiente pagina</span>
              <ChevronRightIcon className='h-4 w-4' />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
